import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	deleteModalTitle: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-title',
		defaultMessage: 'Delete priority scheme',
		description: 'Delete priority scheme modal title',
	},
	deleteModalTitleWithNoAssociatedProject: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-title-with-no-associated-project',
		defaultMessage: 'Delete scheme "{schemeName}"',
		description: 'Delete priority scheme modal title',
	},
	deleteModalDescription: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-description',
		defaultMessage: `There may be some projects associated with the scheme “{schemeName}” that have been moved to
            trash or archived. These projects will be associated with the default priority scheme, and their issues will be assigned to the default priority.`,
		description: 'Delete priority scheme modal description',
	},
	deleteModalDescriptionWithNoAssociatedProject: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-description-with-no-associated-project',
		defaultMessage: 'This scheme has no associated projects and can be deleted.',
		description: 'Delete priority scheme modal description',
	},
	deleteModalCancelButtonTitle: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-cancel-button-title',
		defaultMessage: 'Cancel',
		description: 'Delete priority scheme modal cancel button title',
	},
	deleteModalDeleteButtonTitle: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-delete-button-title',
		defaultMessage: 'Delete',
		description: 'Delete priority scheme modal submit button title',
	},
});
